module.exports = __webpack_public_path__ + "media/images/whatsapp_black-e868911a6a6f0f7106c597301818286a.svg";